export default {
  OPEN: 'open',
  LOST: 'lost',
  WON: 'won',
  JACKPOT: 'jackpot',
  IN_PLAY: 'in_play',
  PAIDOUT: 'paidout',
};
